<template>
  <div
    v-if="width && height"
    :style="{
      width: `${width}px`,
      height: `${height}px`,
    }"
  >
    <Iframe
      :url="url"
      :Authorization="Authorization"
      :customerId="customerId"
      class="iframe1"
      id="iframe1"
    >
    </Iframe>
  </div>
</template>
<script>
import Viewport from "@/utils/viewport";
import Iframe from "@/views/components/base/Iframe";

export default {
  name: "enter",
  components: {
    Iframe,
  },
  data() {
    return {
      url: null,
      Authorization: null,
      customerId: null,
      width: null,
      height: null,
    };
  },

  mounted() {
    const me = this;

    me.Authorization = global.$utils.data.get("", "token");
    me.customerId = window.localStorage.getItem("customerId");
    // me.url = "http://localhost:8080";

    me.url = "https://uihkmed.hi-eweibao.com";
    this.viewport = new Viewport(this);
  },
  destroyed() {
    this.viewport.onDestroyed();
  },
};
</script>
